import { render, staticRenderFns } from "./UserWant.vue?vue&type=template&id=7beb119b&scoped=true"
import script from "./UserWant.vue?vue&type=script&lang=js"
export * from "./UserWant.vue?vue&type=script&lang=js"
import style0 from "./UserWant.vue?vue&type=style&index=0&id=7beb119b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb119b",
  null
  
)

export default component.exports